<template>
	<div class="wai">
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">新建标签</div>
		</div>
		<div class="demo1">
			<div class="demo1_list1">
				<div>标签名称</div>
				<div>
					<el-input size="small" maxlength="20" show-word-limit v-model="filter.labelName"
						style="width: 300px;" type="text" placeholder="人群名称,不超过20个字(不能含标点符号)"></el-input>
				</div>
			</div>
			<div class="demo1_list1">
				<div>标签描述</div>
				<div>
					<el-input maxlength="50" show-word-limit style="width: 300px;" size="small"
						v-model="filter.labelDesc" type="textarea" :rows="3" placeholder="请输入标签描述">
					</el-input>
				</div>
			</div>
			<div class="demo1_list1">
				<div>美团用户</div>
				<div class="demo1_radaios">
					<el-checkbox v-model="filter.hasMeituan" :label="1">购买过美团订单</el-checkbox>
				</div>
			</div>
			<div class="demo1_list1">
				<div>VIP用户</div>
				<div class="demo1_radaios">
					<el-radio v-model="filter.hasVip" :label="1">是否为VIP</el-radio>
					<el-radio v-model="filter.hasVip" :label="2">不为VIP</el-radio>
				</div>
			</div>
			<div class="demo1_list1">
				<div>交易次数</div>
				<div>
					<el-checkbox v-model="filter.judgePayCount" label="1">需交易</el-checkbox>
					最低
					<el-input-number size="mini" :min="0" :controls='false' v-model="filter.minTransactions"
						style="width:80px;margin:0px 5px;" :disabled="filter.judgePayCount==0"></el-input-number>
					次；最高
					<el-input-number size="mini" :min="0" :controls='false' v-model="filter.maxTransactions"
						style="width:80px;margin:0px 5px;" :disabled="filter.judgePayCount==0"></el-input-number>
					次
				</div>
			</div>
			<div class="demo1_list1">
				<div>选择服务</div>
				<el-checkbox-group v-model="filter.services" style="width:800px">
					<span v-for="i in serviceList" :key="i.id" style="display:inline-block; margin-right: 20px">
						<el-checkbox :label="i.id+''">{{ i.title }}</el-checkbox>
					</span>
				</el-checkbox-group>
			</div>
			<div class="demo1_list1">
				<div>选择门店</div>
				<el-checkbox-group v-model="filter.storeId" style="width:800px">
					<span v-for="k in storeList" :key="k.id" style="display:inline-block; margin-right: 20px">
						<el-checkbox :label="k.id+''">{{ k.title }}</el-checkbox>
					</span>
				</el-checkbox-group>
			</div>
		</div>
		<div class="mybotton">
			<el-button @click="goback">取消</el-button>
			<el-button type="primary" @click="add">保存</el-button>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				filter: {
					labelName: "", //标签名称
					labelDesc: "", //标签描述
					updateWay: "", //付款方式
					payTotal: "", //付款金额
					nearBuy: "", //最近是否购买
					numberOfTransactions: 0, //交易次数
					firstBuy: "", //是否首次购买
					hasVip: 0,
					hasMeituan: 0,
					judgePayCount: 0,
					minTransactions: 0,
					maxTransactions: undefined,
					services: [],
					storeId: [],
				},
				serviceList: [],
				storeList: []
			}
		},
		mounted() {
			this.getService();
			this.getStoreList();
		},
		methods: {
			getlist() {
				this.$http.get("dUserLabel/getById?id=" + this.$route.query.id).then(function(res) {
					if (res.body.code == 200) {
						this.filter = res.body.data
						if (this.filter.services) {
							this.filter.services = this.filter.services.split(',')
						} else {
							this.filter.services = [];
						}
						if (this.filter.storeId) {
							this.filter.storeId = this.filter.storeId.split(',')
						} else {
							this.filter.storeId = [];
						}
					}
				})
			},
			getStoreList() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 0) {
							this.storeList.push(ele) //结业门店
						}
					})
				})
			},
			getService() {
				let data = {
					pageNum: 1,
					pageSize: 100
				}
				this.$http.post("dhaircut/findDhaircutService", JSON.stringify(data)).then(res => {
					this.serviceList = res.body.data.records;
					if (this.$route.query.id) {
						this.getlist()
					}
				})
			},
			goback() {
				this.$router.go(-1)
			},
			add() {
				if (!this.filter.labelName) return this.$message.error("请输入标签名称");
				if (this.filter.services) this.filter.services = this.filter.services.toString();
				if (this.filter.storeId) this.filter.storeId = this.filter.storeId.toString();
				this.$http.post("dUserLabel/saveOrUpdate", JSON.stringify(this.filter)).then(function(res) {
					if (res.body.code == 200) {
						if (this.$route.query.id) {
							this.$message.success("修改成功");
						} else {
							this.$message.success("添加成功");
						}
						this.$router.push("/operaplan")
						// this.$router.go(-1)
					} else {
						this.$message.error(res.body.msg);
					}
				})
			},
		}
	};
</script>
<style lang="less" scoped>
	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;
		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	// 第一部分
	.demo1 {
		width: 100%;

		.demo1_list1 {
			margin-top: 20px;
			display: flex;
			div {
				&:nth-child(1) {
					width: 200px;
				}
			}

			.demo1_radaios {
				display: flex;
			}
		}

		// <div class="demo1_list1">
		// 			    <div>标签名称</div>
		// 				<div>
		// 					<el-input size="small" type="text" placeholder="人群名称,不超过20个字(不能含标点符号)"></el-input>
		// 				</div>
		// </div>
		// <div class="demo1_list1">
		// 			    <div>标签名称</div>
		// 				<div>
		// 					<el-input size="small" type="text" placeholder="人群名称,不超过20个字(不能含标点符号)"></el-input>
		// 				</div>
		// </div>

	}

	// 第二部分
	.demo2 {
		box-sizing: border-box;
		width: 100%;
		padding: 20px;
		padding-top: 10px;
		display: flex;
		flex-wrap: wrap;
		border: 1px solid #D3D3D3;
		.demo2_label {
			cursor: pointer;
			height: 23px;
			margin-top: 10px;
			padding: 10px;
			background: #FFFFFF;
			border: 1px solid #D3D3D3;
			position: relative;

			& {
				margin-right: 20px;
			}

			&:hover div {
				display: block;
			}

			div {
				display: none;
				text-align: center;
				line-height: 12px;
				font-size: 12px;
				color: #FFFFFF;
				border-radius: 50%;
				position: absolute;
				right: -5px;
				top: -5px;
				height: 15px;
				width: 15px;
				background-color: #000000;
			}
		}

		.demo2_add {
			height: 23px;
			margin-top: 10px;
			cursor: pointer;
			padding: 10px;
			background: #FFFFFF;
			border: 1px dashed #D3D3D3;
		}
	}

	// 第三部分
	.screen {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		.screenlist {
			width: 351px;
			height: 323px;
			box-sizing: border-box;
			padding: 20px;
			background: #EEEEEE;

			&:nth-child(n+2) {
				margin-left: 20px;
			}

			p {
				line-height: 0;
			}
		}
	}

	// botton
	.mybotton {
		margin-top: 50px;
		margin-bottom: 100px;
		margin-left: 10%;
	}
</style>